import React, { Component } from 'react';

class RoleTemplate extends Component {
  	render(){
		return (
			<div>
				<h3>Role templates</h3>
			</div>
		)
	}
}

export default RoleTemplate;


// WEBPACK FOOTER //
// ./src/pages/manage_users/RoleTemplatePage.js